module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


// WEBPACK FOOTER //
// ./~/babel-runtime/~/core-js/library/modules/_a-function.js